const handleInputChange = (event, key, values, setValues) => {
  setValues({ ...values, [key]: event.target.value });
};

export default handleInputChange;
